import Vue from 'vue'
import VueRouter from 'vue-router'
import api from '@/api'
Vue.use(VueRouter)

const routes = [{
    //登录
    path: '/',
    name: 'login',
    component: () => import('@/views/login/indexLogin'),
  },
  {
    //注册
    path: '/user/indexUser',
    name: 'user',
    component: () => import('@/views/user/indexUser'),
  },
  {
    //操作视频
    path: '/operationVideo',
    name: 'operationVideo',
    component: () => import('@/views/login/operationVideo'),
  },
  {
    //忘记密码
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: () => import('@/views/login/forgetPassword'),
  },
  //企业认证
  {
    path: '/user/UserViewOne',
    name: 'UserViewOne',
    component: () => import('@/views/user/UserViewOne'),
  },
  {
    path: '/user/UserViewThree',
    name: 'UserViewThree',
    component: () => import('@/views/user/UserViewThree'),
  },
  //自荐
  {
    path: '/user/UserViewSelf',
    name: 'UserViewSelf',
    component: () => import('@/views/user/UserViewSelf'),
  },
  //注册完成
  {
    path: '/user/indexUserOk',
    name: 'indexUserOk',
    component: () => import('@/views/user/indexUserOk'),
  },
  //化工宝服务条款
  {
    path: '/user/UesrPact',
    name: 'UesrPact',
    component: () => import('@/views/user/UesrPact'),
  },
  //隐私条款
  {
    path: '/user/UesrPrivacy',
    name: 'UesrPrivacy',
    component: () => import('@/views/user/UesrPrivacy'),
  },

  {
    //服务购买 one
    path: '/purchaseOne',
    name: 'purchaseOne',
    component: () => import('@/views/payment/purchaseOne'),
  },
  {
    //服务购买 Two
    path: '/purchaseTwo',
    name: 'purchaseTwo',
    component: () => import('@/views/payment/purchaseTwo'),
  },
  {
    //服务购买 Three
    path: '/purchaseThree',
    name: 'purchaseThree',
    component: () => import('@/views/payment/purchaseThree'),
  },

  {
    //首页
    path: '/HomeView',
    name: 'home',
    component: () => import('@/views/Home/HomeView.vue'),
    // redirect:{name:'adminDissent'},
    children: [
      // 客户工作台
      {
        path: '/customerWorkbench/myWorkStation',
        name: 'customerWorkbench_myWorkStation',
        component: () => import('@/views/Home/customerWorkbench/myWorkStation/myWorkStation.vue'),
      },
      // 客户工作台 - 交易管理 - 竞价交易
      {
        path: '/customerWorkbench/competitivePriceTransaction',
        name: 'customerWorkbench_competitivePriceTransaction',
        component: () => import('@/views/Home/customerWorkbench/transactionManagement/competitivePriceTransaction/competitivePriceTransaction.vue'),
      },
      // 客户工作台 - 交易管理 - 挂牌交易
      {
        path: '/customerWorkbench/listingTransaction',
        name: 'customerWorkbench_listingTransaction',
        component: () => import('@/views/Home/customerWorkbench/transactionManagement/listingTransaction/listingTransaction.vue'),
      },
      // 客户工作台 - 我的合同
      {
        path: '/customerWorkbench/myContract',
        name: 'customerWorkbench_myContract',
        component: () => import('@/views/Home/customerWorkbench/myContract/myContract/myContract.vue'),
      },
      // 客户工作台 - 我的合同
      {
        path: '/customerWorkbench/myContractDetail',
        name: 'customerWorkbench_myContractDetail',
        component: () => import('@/views/Home/customerWorkbench/myContract/myContractDetail/myContractDetail.vue'),
      },
      // 客户工作台 - 我的合同 - 创建提货计划
      {
        path: '/customerWorkbench/createPickingPlan',
        name: 'customerWorkbench_createPickingPlan',
        component: () => import('@/views/Home/customerWorkbench/myContract/createPickingPlan.vue'),
      },
      // 客户工作台 - 物流管理 - 提货委托管理
      {
        path: '/customerWorkbench/ConsignmentManagement',
        name: 'customerWorkbench_ConsignmentManagement',
        component: () => import('@/views/Home/customerWorkbench/logisticsManagement/ConsignmentManagement/ConsignmentManagement.vue'),
      },
      // 客户工作台 - 物流管理 - 提货委托管理详情
      {
        path: '/customerWorkbench/ConsignmentManagementDetail/:id',
        name: 'customerWorkbench_ConsignmentManagementDetail',
        component: () => import('@/views/Home/customerWorkbench/logisticsManagement/ConsignmentManagementDetail/ConsignmentManagementDetail.vue'),
      },
      // 客户工作台 - 物流管理 - 提货计划管理    
      {
        path: '/customerWorkbench/deliveryPlan',
        name: 'customerWorkbench_deliveryPlan',
        component: () => import('@/views/Home/customerWorkbench/logisticsManagement/deliveryPlan/deliveryPlan.vue'),
      },
      // 客户工作台 - 物流管理 - 提货计划管理详情    
      {
        path: '/customerWorkbench/deliveryPlanDetail',
        name: 'customerWorkbench_deliveryPlanDetail',
        component: () => import('@/views/Home/customerWorkbench/logisticsManagement/deliveryPlanDetail/deliveryPlanDetail.vue'),
      },
      // 客户工作台 - 物流管理 - 提货单管理
      {
        path: '/customerWorkbench/billOfLading',
        name: 'customerWorkbench_billOfLading',
        component: () => import('@/views/Home/customerWorkbench/logisticsManagement/billOfLading/billOfLading.vue'),
      },
      // 客户工作台 - 物流管理 - 提货单管理详情
      {
        path: '/customerWorkbench/billOfLadingDetail',
        name: 'customerWorkbench_billOfLadingDetail',
        component: () => import('@/views/Home/customerWorkbench/logisticsManagement/billOfLadingDetail/billOfLadingDetail.vue'),
      },
      // 客户工作台-运输任务 --提货管理(炭黑)
      {
        path: '/customerWorkbench/carbonblackDelivery',
        name: 'customerWorkbench_carbonblackDelivery',
        component: () => import('@/views/Home/customerWorkbench/logisticsManagement/carbonblackDelivery/index')
      },
      // 客户工作台-运输任务 --提货管理(炭黑)--详情
      {
        path: '/customerWorkbench/carbonblackDelivery/details',
        name: 'customerWorkbench_carbonblackDelivery_details',
        component: () => import('@/views/Home/customerWorkbench/logisticsManagement/carbonblackDelivery/details')
      },
      // 客户工作台 - 物流管理 - 常用车辆
      {
        path: '/customerWorkbench/commonVehicles',
        name: 'customerWorkbench_commonVehicles',
        component: () => import('@/views/Home/customerWorkbench/logisticsManagement/commonVehicles/commonVehicles.vue'),
      },
      // 客户工作台 - 物流管理 - 新增常用车辆
      {
        path: '/customerWorkbench/addComCar',
        name: 'customerWorkbench_addComCar',
        component: () => import('@/views/Home/customerWorkbench/logisticsManagement/commonVehicles/addComCar.vue'),
      },
      // 客户工作台-物流管理-常用车辆详情
      {
        path: '/customerWorkbench/commonVehiclesDetails',
        name: 'customerWorkbench_commonVehiclesDetails',
        component: () => import('@/views/Home/customerWorkbench/logisticsManagement/commonVehicles/commonVehiclesDetails.vue')
      },
      // 客户工作台 - 物流管理 - 我的船舶
      {
        path: '/customerWorkbench/commonVessel',
        name: 'customerWorkbench_commonVessel',
        component: () => import('@/views/Home/customerWorkbench/logisticsManagement/commonVessel/commonVessel.vue'),
      },
      // 客户工作台 - 物流管理 - 新增我的船舶
      {
        path: '/customerWorkbench/addCommonVessel',
        name: 'customerWorkbench_addCommonVessel',
        component: () => import('@/views/Home/customerWorkbench/logisticsManagement/commonVessel/addComVessel.vue'),
      },
    
      // 客户工作台 - 结算管理
      {
        path: '/customerWorkbench/settlementManagement',
        name: 'customerWorkbench_settlementManagement',
        component: () => import('@/views/Home/customerWorkbench/settlementManagement/settlementManagement/settlementManagement.vue'),
      },
      // 客户工作台 - 结算管理 - 详情
      {
        path: '/customerWorkbench/settlementManagementDetail/:id',
        name: 'customerWorkbench_settlementManagementDetail',
        component: () => import('@/views/Home/customerWorkbench/settlementManagement/settlementManagementDetail/settlementManagementDetail.vue'),
      },
      // 客户工作台 - 异议管理
      {
        path: '/customerWorkbench/dissentManagement',
        name: 'customerWorkbench_dissentManagement',
        component: () => import('@/views/Home/customerWorkbench/dissentManagement/dissentManagement.vue'),
      },
      // 客户工作台 - 异议管理详情
      {
        path: '/customerWorkbench/dissentManagementDetail/:id',
        name: 'customerWorkbench_dissentManagementDetail',
        component: () => import('@/views/Home/customerWorkbench/dissentManagement/dissentManagementDetail.vue'),
      },
      // 客户工作台 - 授信管理 - 资金授信
      {
        path: '/customerWorkbench/capitalCredit',
        name: 'customerWorkbench_capitalCredit',
        component: () => import('@/views/Home/customerWorkbench/creditManagement/capitalCredit/capitalCredit.vue'),
      },
      // 客户工作台 - 需求管理 - 月度需求
      {
        path:'/customerWorkbench/monthlyDemand',
        name: 'customerWorkbench_monthlyDemand',
        meta:{
          keepLive:true
        },
        component: () => import('@/views/Home/customerWorkbench/demandManagement/monthlyDemand/monthlyDemand.vue')
      },
      // 客户工作台 - 需求管理 - 月度需求 - 新增
      {
        path:'/customerWorkbench/monthlyDemandAdd/:id',
        name: 'customerWorkbench_monthlyDemandAdd',
        component: () => import('@/views/Home/customerWorkbench/demandManagement/monthlyDemand/monthlyDemandAdd/monthlyDemandAdd.vue')
      },
        // 客户工作台 - 需求管理 - 报价单
      {
        path:'/customerWorkbench/priceSheet',
        name: 'customerWorkbench_priceSheet',
        component: () => import('@/views/Home/customerWorkbench/demandManagement/priceSheet/priceSheet.vue')
      },
      // 客户工作台 - 需求管理 - 报价单详情
      {
        path:'/customerWorkbench/priceSheetDet/id=:id',
        name: 'customerWorkbench_priceSheetDet',
        component: () => import('@/views/Home/customerWorkbench/demandManagement/priceSheet/priceSheetDet/priceSheetDet')
      },
      // 原料供应商工作台
      // 原料供应商工作台 - 我的工作台
      {
        path: '/supplierWorkbench/myWorkbench',
        name: 'supplierWorkbench_myWorkbench',
        component: () => import('@/views/Home/supplierWorkbench/myWorkbench/myWorkbench.vue'),
      },
      // 原料供应商工作台 - 我的询比价
      {
        path: '/supplierWorkbench/adminPriceComparison',
        name: 'supplierWorkbench_adminPriceComparison',
        component: () => import('@/views/Home/supplierWorkbench/priceComparison/adminPriceComparison/adminPriceComparison.vue'),
      },
      // 原料供应商工作台 - 我的询比价详情
      {
        path: '/supplierWorkbench/adminPriceComparisonDetail/:id',
        name: 'supplierWorkbench_adminPriceComparisonDetail',
        component: () => import('@/views/Home/supplierWorkbench/priceComparison/adminPriceComparisonDetail/adminPriceComparisonDetail.vue'),
      },
      // 原料供应商工作台 - 我的合同
      {
        path: '/supplierWorkbench/adminContract',
        name: 'supplierWorkbench_adminContract',
        component: () => import('@/views/Home/supplierWorkbench/contractManagement/adminContract/adminContract.vue'),
      },
      // 原料供应商工作台 - 我的合同详情
      {
        path: '/supplierWorkbench/adminContractDetail',
        name: 'supplierWorkbench_adminContractDetail',
        component: () => import('@/views/Home/supplierWorkbench/contractManagement/adminContractDetail/adminContractDetail.vue'),
      },
      // 原料供应商工作台 - 物流管理
      //  {
      //   path:'/physicalDistributionManagement',
      //   name: 'physicalDistributionManagement',
      //   redirect:{name:'supplierWorkbench_adminPicking'},
      //   component:()=> import('@/views/Home/physicalDistributionManagement/adminPhysicalDistribution.vue'),
      // },
      //  原料供应商工作台 - 物流管理 - 到货计划管理
      {
        path: '/supplierWorkbench/arrivalPlanManagement',
        name: 'supplierWorkbench_arrivalPlanManagement',
        component: () => import('@/views/Home/supplierWorkbench/physicalDistribution/arrivalPlanManagement/arrivalPlanManagement.vue'),
      },
      //  原料供应商工作台 - 物流管理 - 到货计划管理详情
      {
        path: '/supplierWorkbench/arrivalPlanManagementDetail',
        name: 'supplierWorkbench_arrivalPlanManagement',
        component: () => import('@/views/Home/supplierWorkbench/physicalDistribution/arrivalPlanManagementDetail/arrivalPlanManagementDetail.vue'),
      },
      // 原料供应商工作台 - 物流管理 - 到货单管理
      {
        path: '/supplierWorkbench/IncomingManifest',
        name: 'supplierWorkbench_IncomingManifest',
        component: () => import('@/views/Home/supplierWorkbench/physicalDistribution/IncomingManifest/IncomingManifest.vue'),
      },
      // 原料供应商工作台 - 物流管理 - 到货单管理详情
      {
        path: '/supplierWorkbench/IncomingManifestDetail',
        name: 'supplierWorkbench_IncomingManifest',
        component: () => import('@/views/Home/supplierWorkbench/physicalDistribution/IncomingManifestDetail/IncomingManifestDetail.vue'),
      },
      // 原料供应商工作台 - 物流管理 - 常用车辆
      {
        path: '/supplierWorkbench/commonVehicles',
        name: 'supplierWorkbench_commonVehicles',
        component: () => import('@/views/Home/supplierWorkbench/physicalDistribution/commonVehicles/commonVehicles.vue'),
      },
      // 原料供应商工作台 - 物流管理 - 常用车辆
      {
        path: '/supplierWorkbench/addComCar',
        name: 'supplierWorkbench_addComCar',
        component: () => import('@/views/Home/supplierWorkbench/physicalDistribution/commonVehicles/addComCar.vue'),
      },
      // 原料供应商工作台 - 物流管理 - 我的船舶
      {
        path: '/supplierWorkbench/commonVessel',
        name: 'supplierWorkbench_commonVessel',
        component: () => import('@/views/Home/supplierWorkbench/physicalDistribution/commonVessel/commonVessel.vue'),
      },
      // 原料供应商工作台 - 物流管理 - 新增我的船舶
      {
        path: '/supplierWorkbench/addCommonVessel',
        name: 'supplierWorkbench_addCommonVessel',
        component: () => import('@/views/Home/supplierWorkbench/physicalDistribution/commonVessel/addComVessel.vue'),
      },
      // 原料供应商工作台-运输任务-常用车辆详情
      {
        path: '/supplierWorkbench/commonVehiclesDetails',
        name: 'supplierWorkbench_commonVehiclesDetails',
        component: () => import('@/views/Home/supplierWorkbench/physicalDistribution/commonVehicles/commonVehiclesDetails.vue')
      },
      // 原料供应商工作台 - 结算管理
      {
        path: '/supplierWorkbench/invoiceQuery',
        name: 'supplierWorkbench_invoiceQuery',
        component: () => import('@/views/Home/supplierWorkbench/settlementManagement/invoiceQuery/invoiceQuery.vue'),
      },
      // 原料供应商工作台 - 结算管理详情
      {
        path: '/supplierWorkbench/invoiceQueryDetail/:id',
        name: 'supplierWorkbench_invoiceQueryDetail',
        component: () => import('@/views/Home/supplierWorkbench/settlementManagement/invoiceQueryDetail/invoiceQueryDetail.vue'),
      },
      // 原料供应商工作台 - 异议管理
      {
        path: '/supplierWorkbench/adminDissent',
        name: 'supplierWorkbench_adminDissent',
        component: () => import('@/views/Home/supplierWorkbench/dissentManagement/adminDissent/adminDissent.vue'),
      },
      // 原料供应商工作台 - 异议管理详情
      {
        path: '/supplierWorkbench/adminDissentDetail/:id',
        name: 'supplierWorkbench_adminDissentDetail',
        component: () => import('@/views/Home/supplierWorkbench/dissentManagement/adminDissentDetail/adminDissentDetail.vue'),
      },
      // 原料供应商工作台 -用户和权限 -角色管理
      {
        path: '/supplierWorkbench/roleManagement',
        name: 'supplierWorkbench_roleManagement',
        component: () => import('@/views/Home/supplierWorkbench/usersAndPermissions/roleManagement/roleManagement.vue'),
      },
      // 原料供应商工作台 -用户和权限 -员工权限管理
      {
        path: '/supplierWorkbench/employeeRightsManagement',
        name: 'supplierWorkbench_employeeRightsManagement',
        component: () => import('@/views/Home/supplierWorkbench/usersAndPermissions/employeeRightsManagement/employeeRightsManagement.vue'),
      },
      // 原料供应商工作台 -企业管理- 企业简历
      {
        path: '/supplierWorkbench/companiesResume',
        name: 'supplierWorkbench_companiesResume',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/companiesResume/companiesResume.vue'),
      },
      // 原料供应商工作台 -企业管理- 客商自荐
      {
        path: '/supplierWorkbench/recommendationFrom',
        name: 'supplierWorkbench_recommendationFrom',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/recommendationFrom/recommendationFrom.vue'),
      },
      // 原料供应商工作台 -企业管理- 数字证书
      {
        path: '/supplierWorkbench/digitalCertificate',
        name: 'supplierWorkbench_digitalCertificate',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/digitalCertificate/digitalCertificate.vue'),
      },
      // 原料供应商工作台 -企业管理- 数字证书新增
      {
        path: '/supplierWorkbench/addDigitalCertificate/:id',
        name: 'supplierWorkbench_addDigitalCertificate',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/digitalCertificate/addDigitalCertificate/addDigitalCertificate.vue'),
      },
      // 原料供应商工作台 -企业管理- 资质证书
      {
        path: '/supplierWorkbench/qualificationCertificate',
        name: 'supplierWorkbench_qualificationCertificate',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/qualificationCertificate/qualificationCertificate.vue'),
      },
      // 原料供应商工作台 -企业管理- 资质证书新增
      {
        path: '/supplierWorkbench/addQualificationCertificate/:id',
        name: 'supplierWorkbench_addQualificationCertificate',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/qualificationCertificate/addQualificationCertificate/addQualificationCertificate.vue'),
      },

      // 原料供应商工作台 -企业管理- 工商信息
      {
        path: '/supplierWorkbench/businessInformation',
        name: 'supplierWorkbench_businessInformation',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/businessInformation/businessInformation.vue'),
      },
      // 原料供应商工作台 -企业管理- 公司概况
      {
        path: '/supplierWorkbench/companyProfile',
        name: 'supplierWorkbench_companyProfile',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/companyProfile/companyProfile.vue'),
      },
      // 原料供应商工作台 -企业管理- 备修协同
      {
        path: '/supplierWorkbench/maintain',
        name: 'supplierWorkbench_maintain',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/maintain/maintain.vue'),
      },
      // 原料供应商工作台 -企业管理- 添加成功
      {
        path: '/supplierWorkbench/successfullyAdded',
        name: 'supplierWorkbench_successfullyAdded',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/successfullyAdded/successfullyAdded.vue'),
      },
      // 原料供应商工作台 -企业管理- 开票信息
      {
        path: '/supplierWorkbench/billingInformation',
        name: 'supplierWorkbench_billingInformation',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/billingInformation/billingInformation.vue'),
      },
      // 原料供应商工作台 -企业管理- 银行信息
      {
        path: '/supplierWorkbench/bankInformation',
        name: 'supplierWorkbench_bankInformation',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/bankInformation/bankInformation.vue'),
      },
      // 原料供应商工作台 -企业管理- 银行信息添加
      {
        path: '/supplierWorkbench/addBankInformation/:id',
        name: 'supplierWorkbench_addBankInformation',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/bankInformation/addBankInformation.vue'),
      },
      {
        path: '/supplierWorkbench/editBankInformation/:id',
        name: 'supplierWorkbench_editBankInformation',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/bankInformation/editBankInformation.vue'),
      },
      // 原料供应商工作台 -企业管理- 地址信息
      {
        path: '/supplierWorkbench/addressInformation',
        name: 'supplierWorkbench_addressInformation',
        component: () => import('@/views/Home/supplierWorkbench/businessAdministration/addressInformation/addressInformation.vue'),
      },
      // -------
      // 原料供应商工作台 -用户中心 -个人中心
      {
        path: '/supplierWorkbench/personalCenter',
        name: 'supplierWorkbench_personalCenter',
        component: () => import('@/views/Home/supplierWorkbench/userCenter/personalCenter/personalCenter.vue'),


      },
      // 修改密码
      {
        path: '/supplierWorkbench/personalCenter/changePassword',
        name: 'supplierWorkbench_changePassword',
        component: () => import('@/views/Home/supplierWorkbench/userCenter/personalCenter/components/changePassword.vue'),
      },
      // 新增企业关系
      {
        path: '/supplierWorkbench/personalCenter/addRelation',
        name: 'supplierWorkbench_addRelation',
        component: () => import('@/views/Home/supplierWorkbench/userCenter/personalCenter/components/addRelation.vue'),
      },
      // 原料供应商工作台 -用户中心 -员工管理
      {
        path: '/supplierWorkbench/employeeManagement',
        name: 'supplierWorkbench_employeeManagement',
        component: () => import('@/views/Home/supplierWorkbench/userCenter/employeeManagement/employeeManagement.vue')
      },
      // 原料供应商工作台 - 结算单
      {
        path: '/supplierWorkbench/settlementManagement',
        name: 'supplierWorkbench_settlementManagement',
        component: () => import('@/views/Home/supplierWorkbench/settlement/settlement.vue')
      },
      // 原料供应商工作台-结算管理-结算单管理-结算单详情
      {
        path: '/supplierWorkbench/settlementManagement/settlementDet/:id',
        name: 'supplierWorkbench_settlementDet',
        component: () => import('@/views/Home/supplierWorkbench/settlement/settlementDet/settlementDet.vue')
      },
      // 原料供应商工作台-结算管理（发票列表）
      {
        path: '/supplierWorkbench/invoiceList',
        name: 'supplierWorkbench_invoiceList',
        component: () => import('@/views/Home/supplierWorkbench/settlement/invoiceList/invoiceList.vue')
      },
      // 原料供应商工作台-结算管理（发票列表）-发票详情
      {
        path: '/supplierWorkbench/invoiceList/invoiceDet/:id/:data',
        name: 'supplierWorkbench_invoiceDet',
        component: () => import('@/views/Home/supplierWorkbench/settlement/invoiceList/invoiceDet/invoiceDet.vue')
      },
      // 承运商工作台------------------------------------------------------------------------------------------
      
      // 承运商工作台-我的工作台
      {
        path: '/carrierWorkbench/myCarrierWorkbench',
        name: 'carrierWorkbench_myCarrierWorkbench',
        component: () => import('@/views/Home/carrierWorkbench/myCarrierWorkbench/myCarrierWorkbench.vue')
      },
      // 承运商工作台-我的合同
      {
        path: '/carrierWorkbench/myContract',
        name: 'carrierWorkbench_myContract',
        component: () => import('@/views/Home/carrierWorkbench/myContract/myContract.vue')
      },
      // 承运商工作台-我的合同-合同详情
      {
        path: '/carrierWorkbench/detailContract',
        name: 'carrierWorkbench_detailContract',
        component: () => import('@/views/Home/carrierWorkbench/myContract/detailContract/detailContract.vue')
      },
      // 承运商工作台-结算管理-结算单管理
      {
        path: '/carrierWorkbench/settlementSheetManagement',
        name: 'carrierWorkbench_settlementSheetManagement',
        component: () => import('@/views/Home/carrierWorkbench/settlementManagement/settlementSheetManagement/settlementSheetManagement.vue'),
      },
      // 承运商工作台-结算管理-结算单管理-结算单详情
      {
        path: '/carrierWorkbench/settlementSheetManagement/statementDetails',
        name: 'carrierWorkbench_statementDetails',
        component: () => import('@/views/Home/carrierWorkbench/settlementManagement/statementDetails/statementDetails.vue')
      },
      // 承运商工作台-结算管理-结算单管理-待结算运单详情
      {
        path: '/carrierWorkbench/settlementSheetManagement/waybillToBeSetDetail',
        name: 'carrierWorkbench_waybillToBeSetDetail',
        component: () => import('@/views/Home/carrierWorkbench/settlementManagement/waybillToBeSetDetail/waybillToBeSetDetail.vue')
      },
      // 承运商工作台-结算管理-待结算运单
      {
        path: '/carrierWorkbench/waybillToBeSettled',
        name: 'carrierWorkbench_waybillToBeSettled',
        component: () => import('@/views/Home/carrierWorkbench/settlementManagement/waybillToBeSettled/waybillToBeSettled.vue')
      },
      // 承运商工作台-结算管理-待结算运单-提交成功
      {
        path: '/carrierWorkbench/commitSuccess',
        name: 'carrierWorkbench_commitSuccess',
        component: () => import('@/views/Home/carrierWorkbench/settlementManagement/commitSuccess/commitSuccess.vue')
      },
      // 承运商工作台-结算管理-发票管理
      {
        path: '/carrierWorkbench/controlInvoice',
        name: 'carrierWorkbench_controlInvoice',
        component: () => import('@/views/Home/carrierWorkbench/settlementManagement/controlInvoice/controlInvoice.vue')
      },
      // 承运商工作台-结算管理-发票管理-发票详情
      {
        path: '/carrierWorkbench/settlementSheetManagement/invoiceDetails',
        name: 'carrierWorkbench_invoiceDetails',
        component: () => import('@/views/Home/carrierWorkbench/settlementManagement/invoiceDetails/invoiceDetails.vue')
      },
      // 承运商工作台-评价中心-年度评价
      {
        path: '/carrierWorkbench/annualEvaluation',
        name: 'carrierWorkbench_annualEvaluation',
        component: () => import('@/views/Home/carrierWorkbench/evaluateCenter/annualEvaluation/annualEvaluation.vue')
      },
      // 承运商工作台-评价中心-年度评价--年度评价详情
      {
        path: '/carrierWorkbench/annualEvaluation/detailsofAnnualEvaluation',
        name: 'carrierWorkbench_detailsofAnnualEvaluation',
        component: () => import('@/views/Home/carrierWorkbench/evaluateCenter/annualEvaluation/detailsofAnnualEvaluation/detailsofAnnualEvaluation.vue')
      },
      // 承运商工作台-评价中心-车辆违规记录
      {
        path: '/carrierWorkbench/vehicleViolationRecord',
        name: 'carrierWorkbench_vehicleViolationRecord',
        component: () => import('@/views/Home/carrierWorkbench/evaluateCenter/vehicleViolationRecord/vehicleViolationRecord.vue')
      },
      // 承运商工作台-运输任务-到货管理
      {
        path: '/carrierWorkbench/arrivalManagement',
        name: 'carrierWorkbench_arrivalManagement',
        meta:{
          keepLive:true
        },
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/arrivalManagement/arrivalManagement.vue')
      },
      // 承运商工作台-运输任务-到货管理--到货计划详情
      {
        path: '/carrierWorkbench/arrivalManagement/arrivalPlanDetails',
        name: 'carrierWorkbench_arrivalPlanDetails',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/arrivalManagement/arrivalPlanDetails/arrivalPlanDetails.vue')
      },
      // 承运商工作台-运输任务-到货管理--到货单详情
      {
        path: '/carrierWorkbench/arrivalManagement/arrivalDetails',
        name: 'carrierWorkbench_arrivalDetails',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/arrivalManagement/arrivalDetails/arrivalDetails.vue')
      },
      // 承运商工作台-运输任务-提货管理
      {
        path: '/carrierWorkbench/pickingManagement',
        name: 'carrierWorkbench_pickingManagement',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/pickingManagement/pickingManagement.vue')
      },
      // 承运商工作台-运输任务-提货管理-提货委托详情
      {
        path: '/carrierWorkbench/consignmentDetails',
        name: 'carrierWorkbench_consignmentDetails',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/pickingManagement/consignmentDetails/consignmentDetails.vue')
      },
      // 承运商工作台-运输任务-提货管理-提货计划详情
      {
        path: '/carrierWorkbench/detailsPickingPlan',
        name: 'carrierWorkbench_detailsPickingPlan',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/pickingManagement/detailsPickingPlan/detailsPickingPlan.vue')
      },
      // 承运商工作台-运输任务-提货管理-提单详情
      {
        path: '/carrierWorkbench/billLadingDetails',
        name: 'carrierWorkbench_billLadingDetails',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/pickingManagement/billLadingDetails/billLadingDetails.vue')
      },
      // 承运商工作台-运输任务-船运管理
      {
        path: '/carrierWorkbench/shippingManagement',
        name: 'carrierWorkbench_shippingManagement',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/shippingManagement/shippingManagement.vue')
      },
      // 承运商工作台-运输任务-船运管理-船运计划详情
      {
        path: '/carrierWorkbench/shippingPlanDetails',
        name: 'carrierWorkbench_shippingPlanDetails',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/shippingManagement/shippingPlanDetails/shippingPlanDetails.vue')
      },
      // 承运商工作台-运输任务-常用车辆
      {
        path: '/carrierWorkbench/commonVehicles',
        name: 'carrierWorkbench_commonVehicles',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/commonVehicles/commonVehicles.vue')
      },
      // 承运商工作台-运输任务-常用车辆详情
      {
        path: '/carrierWorkbench/commonVehiclesDetails',
        name: 'carrierWorkbench_commonVehiclesDetails',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/commonVehicles/commonVehiclesDetails.vue')
      },
      // 承运商工作台-运输任务-新增常用车辆
      {
        path: '/carrierWorkbench/addComCar',
        name: 'carrierWorkbench_addComCar',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/commonVehicles/addComCar.vue')
      },
      // 承运商工作台 - 物流管理 - 我的船舶
      {
        path: '/carrierWorkbench/commonVessel',
        name: 'carrierWorkbench_commonVessel',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/commonVessel/commonVessel.vue'),
      },
      // 承运商工作台 - 物流管理 - 新增我的船舶
      {
        path: '/carrierWorkbench/addCommonVessel',
        name: 'carrierWorkbench_addCommonVessel',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/commonVessel/addComVessel.vue'),
      },
      // 承运商工作台-我的询比价
      {
        path: '/carrierWorkbench/InquireComparePrices',
        name: 'carrierWorkbench_InquireComparePrices',
        component: () => import('@/views/Home/carrierWorkbench/InquireComparePrices/InquireComparePrices.vue')
      },
      // 承运商工作台-我的询比价-我要报名
      {
        path: '/carrierWorkbench/signUp',
        name: 'carrierWorkbench_signUp',
        component: () => import('@/views/Home/carrierWorkbench/InquireComparePrices/signUp/signUp.vue')
      },
      // 承运商工作台-我的询比价-我要报价
      {
        path: '/carrierWorkbench/quotePrice',
        name: 'carrierWorkbench_quotePrice',
        component: () => import('@/views/Home/carrierWorkbench/InquireComparePrices/quote/quotePrice.vue')
      },
      // 承运商工作台-我的询比价-查看详情
      {
        path: '/carrierWorkbench/inquiryDetails',
        name: 'carrierWorkbench_inquiryDetails',
        component: () => import('@/views/Home/carrierWorkbench/InquireComparePrices/inquiryDetails/inquiryDetails.vue')
      },
      // 承运商工作台-车队管理-我的车辆
      {
        path: '/carrierWorkbench/myVehicle',
        name: 'carrierWorkbench_myVehicle',
        component: () => import('@/views/Home/carrierWorkbench/fleetManagement/myVehicle/myVehicle.vue')
      },
      // 承运商工作台-车队管理-我的车辆详情
      {
        path: '/carrierWorkbench/myVehicleDetails',
        name: 'carrierWorkbench_myVehicleDetails',
        component: () => import('@/views/Home/carrierWorkbench/fleetManagement/myVehicle/myVehicleDetails.vue')
      },
      // 承运商工作台-车队管理-我的司机
      {
        path: '/carrierWorkbench/myDriver',
        name: 'carrierWorkbench_myDriver',
        component: () => import('@/views/Home/carrierWorkbench/fleetManagement/myDriver/myDriver.vue')
      },
      // 承运商工作台-车队管理-我的船舶
      {
        path: '/carrierWorkbench/myShipping',
        name: 'carrierWorkbench_myShipping',
        component: () => import('@/views/Home/carrierWorkbench/fleetManagement/myShipping/myShipping.vue')
      },
      // 承运商工作台-车队管理-我的船舶详情
      {
        path: '/carrierWorkbench/myShippingDetails',
        name: 'carrierWorkbench_myShippingDetails',
        component: () => import('@/views/Home/carrierWorkbench/fleetManagement/myShipping/myShippingDetails.vue')
      },

      // 承运商工作台-车队管理-我的船舶详情
      {
        path: '/carrierWorkbench/adminPriceComparison',
        name: 'carrierWorkbench_adminPriceComparison',
        component: () => import('@/views/Home/carrierWorkbench/adminPriceComparison/adminPriceComparison')
      },
       // 承运商工作台-运输任务 --提货管理(炭黑)
       {
        path: '/carrierWorkbench/carbonblackDelivery',
        name: 'carrierWorkbench_carbonblackDelivery',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/carbonblackDelivery/index')
      },
      // 承运商工作台-运输任务 --提货管理(炭黑)--详情
      {
        path: '/carrierWorkbench/carbonblackDelivery/details',
        name: 'carrierWorkbench_carbonblackDelivery_details',
        component: () => import('@/views/Home/carrierWorkbench/transportationTask/carbonblackDelivery/details')
      },
      // 物资供应商工作台 -----------------------------------------------------------------------------------------------
      // 物资供应商工作台 -我的工作台
      {
        path: '/materialSuppliers/myWorkbench',
        name: 'materialSuppliers_myWorkbench',
        component: () => import('@/views/Home/materialSuppliers/myWorkbench/myWorkbench')
      },
      // 物资供应商工作台 -结算管理-发票管理  settlementManagement   managementInvoices
      {
        path: '/materialSuppliers/settlementManagement/managementInvoices',
        name: 'materialSuppliers_managementInvoices',
        component: () => import('@/views/Home/materialSuppliers/settlementManagement/managementInvoices')
      },
      // 物资供应商工作台 -结算管理-发票管理  settlementManagement   managementInvoices
      {
        path: '/materialSuppliers/settlementManagement/managementInvoicesAdd',
        name: 'materialSuppliers_managementInvoicesAdd',
        component: () => import('@/views/Home/materialSuppliers/settlementManagement/managementInvoicesAdd')
      },
      // 物资供应商工作台 -结算管理 - 结算单管理
      {
        path: '/materialSuppliers/settlementManagement/settlementDocumentManagement',
        name: 'materialSuppliers_settlementDocumentManagement',
        component: () => import('@/views/Home/materialSuppliers/settlementManagement/settlementDocumentManagement')
      },
      // 物资供应商工作台 -我的询比价
      {
        path: '/materialSuppliers/adminPriceComparison',
        name: 'materialSuppliers_adminPriceComparison',
        component: () => import('@/views/Home/materialSuppliers/adminPriceComparison/adminPriceComparison')
      },
      // 物资供应商工作台 -我的合同
      {
        path: '/materialSuppliers/myContract',
        name: 'materialSuppliers_myContract',
        component: () => import('@/views/Home/materialSuppliers/myContract/myContract')
      },
      // 物资供应商工作台 -我的合同--详情
      {
        path: '/materialSuppliers/myContract/detailContract',
        name: 'materialSuppliers_myContract_detailContract',
        component: () => import('@/views/Home/materialSuppliers/myContract/detailContract/detailContract')
      },
      // 物资供应商工作台 -我的订单
      {
        path: '/materialSuppliers/myOrder',
        name: 'materialSuppliers_myOrder',
        component: () => import('@/views/Home/materialSuppliers/myOrder/myOrder')
      },
      // 物资供应商工作台 -我的订单--详情
      {
        path: '/materialSuppliers/myOrder/orderDetails',
        name: 'materialSuppliers_myOrder_orderDetails',
        component: () => import('@/views/Home/materialSuppliers/myOrder/detailContract/detailContract')
      },
      // 物资供应商工作台 -送货计划
      {
        path: '/materialSuppliers/deliveryPlan',
        name: 'materialSuppliers_deliveryPlan',
        component: () => import('@/views/Home/materialSuppliers/deliveryPlan/index')
      },
      // 物资供应商工作台 -送货计划 新增
      {
        path: '/materialSuppliers/deliveryPlan/addPlan',
        name: 'materialSuppliers_deliveryPlan_addPlan',
        component: () => import('@/views/Home/materialSuppliers/deliveryPlan/addPlan')
      },
      // 物资供应商工作台 -送货单
      {
        path: '/materialSuppliers/deliveryNote',
        name: 'materialSuppliers_deliveryNote',
        component: () => import('@/views/Home/materialSuppliers/deliveryNote/index')
      },
      // 物资供应商工作台 -送货单 新增
      {
        path: '/materialSuppliers/deliveryNote/addNote',
        name: 'materialSuppliers_deliveryNote_addNote',
        component: () => import('@/views/Home/materialSuppliers/deliveryNote/addNote')
      },
      // 物资供应商工作台 -常用车辆
      {
        path: '/materialSuppliers/commonVehicles',
        name: 'materialSuppliers_commonVehicles',
        component: () => import('@/views/Home/materialSuppliers/commonVehicles/commonVehicles')
      },
      // 物资供应商工作台 -常用车辆- 新增
      {
        path: '/materialSuppliers/commonVehicles/addComCar',
        name: 'materialSuppliers_commonVehicles_addComCar',
        component: () => import('@/views/Home/materialSuppliers/commonVehicles/addComCar')
      },
     
    ]
  },

  {
    name: '404',
    path: '/404',
    component: () => import('@/views/error/errorPage')
  },
  {
    path: '*',
    redirect: '/404'
  },
]

const router = new VueRouter({
  // mode:'history',
  routes
})

// 挂载路由导航守卫
// router.beforeEach((to, from, next) => {
//   if (to.path === '/') return next();
//   //获取token
//   const tokenStr = localStorage.getItem('token')
//   if (!tokenStr) return next('/')
//   next()
// });
// 退登
 router.beforeEach((to, from, next) =>  {
  if(to.query.token){
   api.twice.getKsythLoginInfo(to.query.token).then(res=>{
        // console.log(res,'释放的空间你去俞飞鸿与i');
        // debugger
        if(res.code=='1'){
          localStorage.setItem('token',res.data.token)
          localStorage.setItem('companyInfo',JSON.stringify(res.data.companyInfo))
          return next();
        }else{
          return next();
        }
      })
  }else{
    // console.log(to, from);
      // 退登
      if (to.path === '/'&&to.name=='login') {
        // console.log(localStorage.getItem('token'),'123534rewegftgergre');
        if (localStorage.getItem('token')) {
          api.user.getloginLogout()
          api.user.logoutFromChem()
          localStorage.clear();
        }
        return next();
      } else {
        return next()
      }
  }



});

export default router